// src/config/featureFlags.js
const flags = {
  customCocktails: process.env.REACT_APP_CUSTOM_COCKTAILS_ENABLED === 'true',
};

export const isFeatureEnabled = (flagName) => {
  return Boolean(flags[flagName]);
};

export default flags;
